import Vue from "vue";
export default {
    namespaced: true,
    state: {
        items: [],
        value: null,
    },

    getters: {
        items(state,) {
            return state.items;
        },
    },

    mutations: {
        SET_NULL(state) {
            state.value = null;
        },
        SELECT_CATEGORIA(state, item) {
            state.value = item;
        },
        SET_CATEGORIAS(state, items = []) {
            state.items = items;
        },
        ADD_CATEGORIA(state, oneItem) {
            state.items.push(oneItem);
        },
        DELETE_CATEGORIA(state, Id) {
            const ind = state.items.findIndex(categoria => categoria.id === Id);
            if (ind !== -1) {
                state.items.splice(ind, 1);
            }
        },

        EDIT_CATEGORIA(state, { Id, categoria }) {
            const ind = state.items.findIndex(categoria => categoria.id === Id);

            if (ind !== -1) {
                Vue.set(state.items, ind, categoria);
            }
        }
    },

    actions: {
        setCategoriaNull({ commit }) {
            return (commit('SET_NULL'), true)
        },
        
        selectCategoria({ state, commit }, data) {
            const savedItems = [...state.items]
            let exitsItem = savedItems.find(item => item === data);
            return exitsItem ? (commit('SELECT_CATEGORIA', data), true) : false;
        },

        // first param is context object
        setCategorias({ commit }, data) {
            commit('SET_CATEGORIAS', data);
            return true;
        },
        addCategoria({ state, commit }, data) {
            const savedItems = [...state.items]
            let exitsItem = savedItems.find(item => item.id === data.id);
            return !exitsItem ? (commit('ADD_CATEGORIA', data), true) : false;
        },

        deleteCategoria({ state, commit }, id) {
            const savedItems = [...state.items]
            let exitsItem = savedItems.find(item => item.id === id);
            return exitsItem ? (commit('DELETE_CATEGORIA', id), true) : false;
        },

        // editCategoria({ commit }, data) {
        //     return new Promise(resolve => {
        //         setTimeout(() => {
        //             commit('EDIT_CATEGORIA', data);
        //             resolve();
        //         }, 250);
        //     });
        // }
    }
};
